import * as React from "react";
import { css } from "@emotion/css";
import { navigate } from "../../support/hashRouting";

import bootstrapStyles from "../../css/bootstrap.module.css";

const reviewHeader = css`
  font-size: 18px;
  font-weight: 700;
  color: #555;
  margin-bottom: 16px;
  margin-top: 32px;
  .reviewHeaderDivider {
    padding: 0 4px 0 10px;
  }
  button.btn-review {
    color: #337ab7;
    display: inline-block;
    border: 0;
    background: #fff;
    font-size: 14px;
  }
`;

interface ReviewHeaderProps {
  label: string;
  navigation: string;
}

const ReviewHeader = ({ label, navigation }: ReviewHeaderProps) => {
  return (
    <div className={bootstrapStyles.row}>
      <div className={bootstrapStyles["col-md-12"]}>
        <div className={reviewHeader}>
          {label}
          <span className="reviewHeaderDivider">|</span>
          <button
            className="btn-review"
            type="button"
            onClick={() => {
              navigate(navigation);
            }}
          >
            EDIT
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewHeader;
